enum GlobalSearchItemType {
  ENTITY,
  QUERY,
  LOCAL_QUERY,
  LEAD_FINDER,
  SAVED_LOCATION,
  SET_SAVED_LOCATION,
  ADDRESS,
}

export default GlobalSearchItemType;
